import RestClient from 'rest_client/rest_client';
import { FormEvents } from '../events/form_event_handler';
import { FormAPI } from 'lecom-api';
import { HOST_NAME_API } from '../../../../../shared/serverInfo'

export const execute = (params) => {
	var formDefinitionRequest = buildFormDefinitionRequest(params.definitionURL, params.definitionParams);
	var formAPI = FormAPI.form(params.id);		

	formAPI.publish(FormEvents.DEFINITION_LOAD);
	return new Promise((resolve, reject) => {
		RestClient.performRequest(formDefinitionRequest)
		.then(resolve)
		.catch(handleLoadFormDefinitionError.bind(this, formAPI, reject));
	});
};

function buildFormDefinitionRequest (url, params) {	
	return {
		mime: 'application/json;charset=UTF-8',
		path: `${HOST_NAME_API}${url}`,
		params: Object.assign({}, params)
	};
};

function handleLoadFormDefinitionSuccess (resolve, response) {
	resolve(response);
};

function handleLoadFormDefinitionError (formAPI, reject, reason) {
	formAPI.publish(FormEvents.DEFINITION_LOAD_ERROR, reason);
	reject(reason);
};

export default {
	execute
};
